import React from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/theme-xcode';

export default class CCXML extends React.Component {
    /**
      * Export page
      * @module CCCML
      * @param {Object} props React props
      */
    constructor(props) {
        super(props);
    }
    setConfig(key, value) {
        this[key] = value;
        window.apm.serialized.ccxml = newValue;
        window.apm.serialized.ccxmlLastLocalChange = window.apm.timestamp;
        window.apm.setSerializedChanged();
    }
    onChange(newValue) {
        window.apm.serialized.ccxml = newValue;
        window.apm.serialized.ccxmlLastLocalChange = window.apm.timestamp;
        window.apm.setSerializedChanged();
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <p>
                            <strong>Note:</strong> If a copy of the CCXML file exists on-disk
                            (/usr/local/iact/process-engine/ccxmlFiles/..../app.ccxml),
                            the Process Engine prefers this copy of the file to the CCXML file included in the application itself.
                            Make sure that these files are not stored locally to ensure the Process Engine uses the CCXML in the application.
                        </p>
                    </div>
                </div>
                <AceEditor mode="xml" theme='xcode' context={this} onChange={this.onChange} height="1200px" width="1200px"
                    fontSize={14} showPrintMargin={false} showGutter={true} highlightActiveLine={true} value={this.props.context.props.serialized.ccxml}
                    setOptions={{
                        enableBasicAutocompletion: false,
                        enableLiveAutocompletion: false,
                        enableSnippets: false,
                        showLineNumbers: true,
                        tabSize: 5,
                        useWorker: false
                    }} />
            </div>
        );
    }
}
